module.exports = __webpack_public_path__ + "e9c71d135b28bdc6c929cab40394fad6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/estateBoard.png
// module id = 3238
// module chunks = 0